export default __webpack_public_path__ + "static/media/3.67569509.jpg";